import { render, staticRenderFns } from "./NameAndUrl.vue?vue&type=template&id=2f24aee0&"
import script from "./NameAndUrl.vue?vue&type=script&lang=js&"
export * from "./NameAndUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports